import React from 'react';
import c from 'classnames';

import { SearchkitWrapper } from '@uncinc/react-searchkit';
import type { SearchkitWrapperProps } from '@uncinc/react-searchkit/dist/components/Wrapper';
import type { SearchSettingsConfig } from '@uncinc/react-searchkit/types';

import { facetAttributes, resultAttributes } from './config';
import {
  APP_OPTIONS,
  SEARCHKIT_HITS_PER_PAGE_TOPICAL,
  SEARCHKIT_HOST_URL,
} from '../../config/constants';

// Subcomponents.
import ActiveFacets from './ActiveFacets';
import AdvancedFacets from './AdvancedFacets';
import Facets from './Facets';
import TypeFacet from './TypeFacet';
import Results from './Results';
import ResultsArticles from './Results/Articles';
import ResultsEvents from './Results/Events';

import './style.scss';

interface SearchTopicalSubComponents {
  ActiveFacets: typeof ActiveFacets;
  AdvancedFacets: typeof AdvancedFacets;
  TypeFacet: typeof TypeFacet;
  Facets: typeof Facets;
  Results: typeof Results;
  ResultsArticles: typeof ResultsArticles;
  ResultsEvents: typeof ResultsEvents;
}

export interface SearchTopicalProps extends Omit<SearchkitWrapperProps, 'connection' | 'searchSettings' | 'indexName'> {
  searchSettings?: Partial<SearchSettingsConfig>;
}

const SearchTopical: React.FC<SearchTopicalProps> & SearchTopicalSubComponents = (props) => {
  const {
    className,
    children,
    searchSettings: customSearchSettings,
    ...restProps
  } = props;

  const classNames = c('SearchTopical', className);

  return (
    <SearchkitWrapper
      {...restProps}
      future={{
        preserveSharedStateOnUnmount: true,
      }}
      className={classNames}
      connection={{
        host: SEARCHKIT_HOST_URL,
      }}
      indexName={APP_OPTIONS.parameters.searchkitIndexTopical}
      hitsPerPage={SEARCHKIT_HITS_PER_PAGE_TOPICAL}
      searchSettings={{
        search_attributes: [],
        result_attributes: resultAttributes,
        facet_attributes: facetAttributes,
        ...customSearchSettings,
      }}
    >
      {children}
    </SearchkitWrapper>
  );
};

SearchTopical.ActiveFacets = ActiveFacets;
SearchTopical.AdvancedFacets = AdvancedFacets;
SearchTopical.TypeFacet = TypeFacet;
SearchTopical.Facets = Facets;
SearchTopical.Results = Results;
SearchTopical.ResultsArticles = ResultsArticles;
SearchTopical.ResultsEvents = ResultsEvents;

export default SearchTopical;
